import { createFileRoute, Outlet } from '@tanstack/react-router';

export const Route = createFileRoute('/ngos/projects')({
	component: () => <Outlet />,
});
